// src/pages/ForgotPassword.js
import React, { useState } from "react";
import { Button, Card, Col, Container, Form, Row, Alert, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import pageSvg from "../assets/svg/forgot_password.svg";
import apiClient from "../services/apiClient";

export default function ForgotPassword() {
  const navigate = useNavigate(); // ✅ hook de navigation

  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");
  const [email, setEmail] = useState("");

  // Retirer la sidebar si elle est affichée
  document.body.classList.remove("sidebar-show");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setAlertMessage("");

    // Validation basique de l'email
    if (!email || !email.includes("@")) {
      setAlertVariant("danger");
      setAlertMessage("Veuillez entrer une adresse email valide");
      setIsLoading(false);
      return;
    }

    try {
      const response = await apiClient.post("/send-temp-password", { email });
      const data = response.data;

      if (response.status === 200 || data?.code === 200) {
        setAlertVariant("success");
        setAlertMessage(
          "Un mot de passe temporaire a été envoyé avec succès à votre adresse email ! Redirection vers la page de connexion..."
        );
        setEmail("");

        // ✅ Redirection vers /login après un court délai
        // (laisse le temps à l'utilisateur de voir le message de succès)
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setAlertVariant("danger");
        setAlertMessage(
          data?.message || "Erreur lors de l'envoi du mot de passe temporaire"
        );
        setIsLoading(false); // on réactive le bouton seulement en cas d'erreur
      }
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Erreur de connexion. Veuillez réessayer.";
      setAlertVariant("danger");
      setAlertMessage(backendMessage);
      setIsLoading(false);
    }
    // ⚠️ Pas de finally { setIsLoading(false) } ici :
    // en cas de succès on garde le spinner actif pendant la redirection.
  };

  return (
    <div className="page-auth">
      <div className="content d-flex align-items-center justify-content-center py-3">
        <Container style={{ maxWidth: "600px" }}>
          <Card className="shadow-lg border-0 rounded-4">
            <Card.Body className="text-center p-5">
              <div className="mb-4">
                <object
                  type="image/svg+xml"
                  data={pageSvg}
                  className="w-50"
                  aria-label="Illustration réinitialisation mot de passe"
                ></object>
              </div>

              <Card.Title className="fs-3 fw-semibold mb-3">
                Réinitialiser votre mot de passe
              </Card.Title>
              <Card.Text className="text-muted mb-4">
                Entrez votre adresse email pour recevoir un mot de passe temporaire.
              </Card.Text>

              {alertMessage && (
                <Alert variant={alertVariant} className="mb-4">
                  {alertMessage}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col sm="12">
                    <Form.Group className="mb-3 text-start">
                      <Form.Label className="fw-medium">
                        Adresse email <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="votre@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isLoading}
                        size="lg"
                        className="py-2"
                      />
                      <Form.Text className="text-muted">
                        Nous enverrons le mot de passe temporaire à cette adresse.
                      </Form.Text>
                    </Form.Group>
                  </Col>

                  <Col sm="12">
                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 py-2"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Envoi en cours...
                        </>
                      ) : (
                        "Recevoir un mot de passe temporaire"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>

              <div className="mt-4">
                <span className="text-muted">
                  Vous vous souvenez de votre mot de passe ?{" "}
                </span>
                <Link to="/login" className="fw-semibold text-primary">
                  Se connecter
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </div>
  );
}